/*eslint no-undef: 1*/
/*eslint no-func-assign: 1*/
/*eslint no-unused-vars: 1*/
/*eslint no-cond-assign: 1*/
/*eslint no-prototype-builtins: 1*/

<template>
  <div class="page-laoder">
    <div class="spinner-border text-loader" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
   
  </div>
</template>
<style scoped>
.page-laoder {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* height: 100vh;  
  position: absolute; */
  z-index: 999;
  background: var(--m3--read-only--light--secondary-container--opacity-016);
}

.text-loader {
  --bs-text-opacity: 1;
  border: 0.25em solid var(--m3--sys--light--primary);
  border-right-color: transparent;
}

.page-laoder {
  margin-top: 60px;
}

.spinner-border {
  width: 5rem !important;
  height: 5rem !important;
}
</style>